/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BaseConfig } from '../models/base-config';
import { BaseConfigPartial } from '../models/base-config-partial';
import { BaseConfigWithRelations } from '../models/base-config-with-relations';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class BaseConfigControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation baseConfigControllerCount
   */
  static readonly BaseConfigControllerCountPath = '/base-configs/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, BaseConfigControllerService.BaseConfigControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
    context?: HttpContext
  }
): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation baseConfigControllerFindStatus
   */
  static readonly BaseConfigControllerFindStatusPath = '/base-configs/countStatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  findStatus$Response(params?: {
    emplid?: string;
    status?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, BaseConfigControllerService.BaseConfigControllerFindStatusPath, 'get');
    if (params) {
      rb.query('emplid', params.emplid, {});
      rb.query('status', params.status, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findStatus(params?: {
    emplid?: string;
    status?: string;
    context?: HttpContext
  }
): Observable<{
}> {

    return this.findStatus$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation baseConfigControllerFormNumbers
   */
  static readonly BaseConfigControllerFormNumbersPath = '/base-configs/formNumbers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formNumbers()` instead.
   *
   * This method doesn't expect any request body.
   */
  formNumbers$Response(params?: {
    day?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, BaseConfigControllerService.BaseConfigControllerFormNumbersPath, 'get');
    if (params) {
      rb.query('day', params.day, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `formNumbers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formNumbers(params?: {
    day?: string;
    context?: HttpContext
  }
): Observable<{
}> {

    return this.formNumbers$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation baseConfigControllerWaitSignNumbers
   */
  static readonly BaseConfigControllerWaitSignNumbersPath = '/base-configs/waitSignNumbers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `waitSignNumbers()` instead.
   *
   * This method doesn't expect any request body.
   */
  waitSignNumbers$Response(params?: {
    month?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, BaseConfigControllerService.BaseConfigControllerWaitSignNumbersPath, 'get');
    if (params) {
      rb.query('month', params.month, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `waitSignNumbers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  waitSignNumbers(params?: {
    month?: string;
    context?: HttpContext
  }
): Observable<{
}> {

    return this.waitSignNumbers$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation baseConfigControllerFindById
   */
  static readonly BaseConfigControllerFindByIdPath = '/base-configs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: number;
    filter?: any;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<BaseConfigWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, BaseConfigControllerService.BaseConfigControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BaseConfigWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: number;
    filter?: any;
    context?: HttpContext
  }
): Observable<BaseConfigWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<BaseConfigWithRelations>) => r.body as BaseConfigWithRelations)
    );
  }

  /**
   * Path part for operation baseConfigControllerReplaceById
   */
  static readonly BaseConfigControllerReplaceByIdPath = '/base-configs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `replaceById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceById$Response(params: {
    id: number;
    context?: HttpContext
    body?: BaseConfig
  }
): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, BaseConfigControllerService.BaseConfigControllerReplaceByIdPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `replaceById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceById(params: {
    id: number;
    context?: HttpContext
    body?: BaseConfig
  }
): Observable<any> {

    return this.replaceById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation baseConfigControllerDeleteById
   */
  static readonly BaseConfigControllerDeleteByIdPath = '/base-configs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, BaseConfigControllerService.BaseConfigControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: number;
    context?: HttpContext
  }
): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation baseConfigControllerUpdateById
   */
  static readonly BaseConfigControllerUpdateByIdPath = '/base-configs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: number;
    context?: HttpContext
    body?: BaseConfigPartial
  }
): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, BaseConfigControllerService.BaseConfigControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: number;
    context?: HttpContext
    body?: BaseConfigPartial
  }
): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation baseConfigControllerFind
   */
  static readonly BaseConfigControllerFindPath = '/base-configs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<BaseConfigWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, BaseConfigControllerService.BaseConfigControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<BaseConfigWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
    context?: HttpContext
  }
): Observable<Array<BaseConfigWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<BaseConfigWithRelations>>) => r.body as Array<BaseConfigWithRelations>)
    );
  }

  /**
   * Path part for operation baseConfigControllerUpdateAll
   */
  static readonly BaseConfigControllerUpdateAllPath = '/base-configs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAll()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAll$Response(params?: {
    where?: any;
    context?: HttpContext
    body?: BaseConfigPartial
  }
): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, BaseConfigControllerService.BaseConfigControllerUpdateAllPath, 'patch');
    if (params) {
      rb.query('where', params.where, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateAll$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAll(params?: {
    where?: any;
    context?: HttpContext
    body?: BaseConfigPartial
  }
): Observable<LoopbackCount> {

    return this.updateAll$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation baseConfigControllerGetSendOrdersInfo
   */
  static readonly BaseConfigControllerGetSendOrdersInfoPath = '/users/getSendOrdersInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSendOrdersInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSendOrdersInfo$Response(params?: {
    emplid?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, BaseConfigControllerService.BaseConfigControllerGetSendOrdersInfoPath, 'get');
    if (params) {
      rb.query('emplid', params.emplid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSendOrdersInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSendOrdersInfo(params?: {
    emplid?: string;
    context?: HttpContext
  }
): Observable<{
}> {

    return this.getSendOrdersInfo$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation baseConfigControllerGetSendOrdersInfoTest
   */
  static readonly BaseConfigControllerGetSendOrdersInfoTestPath = '/users/getSendOrdersInfoTest';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSendOrdersInfoTest()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSendOrdersInfoTest$Response(params?: {
    emplid?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, BaseConfigControllerService.BaseConfigControllerGetSendOrdersInfoTestPath, 'get');
    if (params) {
      rb.query('emplid', params.emplid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSendOrdersInfoTest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSendOrdersInfoTest(params?: {
    emplid?: string;
    context?: HttpContext
  }
): Observable<{
}> {

    return this.getSendOrdersInfoTest$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation baseConfigControllerGetSendOrdersInfoTry
   */
  static readonly BaseConfigControllerGetSendOrdersInfoTryPath = '/users/getSendOrdersInfoTry';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSendOrdersInfoTry()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSendOrdersInfoTry$Response(params?: {
    emplid?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, BaseConfigControllerService.BaseConfigControllerGetSendOrdersInfoTryPath, 'get');
    if (params) {
      rb.query('emplid', params.emplid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSendOrdersInfoTry$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSendOrdersInfoTry(params?: {
    emplid?: string;
    context?: HttpContext
  }
): Observable<{
}> {

    return this.getSendOrdersInfoTry$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation baseConfigControllerGetCourseLevelOrAbove
   */
  static readonly BaseConfigControllerGetCourseLevelOrAbovePath = '/users/getUserInfo/getCourseLevelOrAbove';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCourseLevelOrAbove()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCourseLevelOrAbove$Response(params?: {
    emplid?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, BaseConfigControllerService.BaseConfigControllerGetCourseLevelOrAbovePath, 'get');
    if (params) {
      rb.query('emplid', params.emplid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCourseLevelOrAbove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCourseLevelOrAbove(params?: {
    emplid?: string;
    context?: HttpContext
  }
): Observable<{
}> {

    return this.getCourseLevelOrAbove$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation baseConfigControllerGetUserLevel
   */
  static readonly BaseConfigControllerGetUserLevelPath = '/users/getUserInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserLevel()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserLevel$Response(params?: {
    emplid?: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, BaseConfigControllerService.BaseConfigControllerGetUserLevelPath, 'get');
    if (params) {
      rb.query('emplid', params.emplid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUserLevel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserLevel(params?: {
    emplid?: string;
    context?: HttpContext
  }
): Observable<{
}> {

    return this.getUserLevel$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation baseConfigControllerFindFormData
   */
  static readonly BaseConfigControllerFindFormDataPath = '/vw-form-data/findFormData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findFormData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findFormData$Response(params?: {
    emplid?: string;
    status?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<StrictHttpResponse<Array<any>>> {

    const rb = new RequestBuilder(this.rootUrl, BaseConfigControllerService.BaseConfigControllerFindFormDataPath, 'post');
    if (params) {
      rb.query('emplid', params.emplid, {});
      rb.query('status', params.status, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<any>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findFormData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findFormData(params?: {
    emplid?: string;
    status?: string;
    context?: HttpContext
    body?: {
}
  }
): Observable<Array<any>> {

    return this.findFormData$Response(params).pipe(
      map((r: StrictHttpResponse<Array<any>>) => r.body as Array<any>)
    );
  }

}
